import React, {useState, useEffect} from 'react'
import {Dialog, AlertDialog, AlertDialogBody, AlertDialogFooter} from '../../../src/experimental'
import {AtlasButton, Box} from '@fuegokit/react'

export const AlertDialogDefaultExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)

  useEffect(() => {
    setDomLoaded(true)
  }, [])

  return (
    <Box>
      {domLoaded && (
        <Dialog>
          <Dialog.Trigger asChild>
            <AtlasButton sx={{backgroundColor: 'background.information.default.[default]', fontSize: 3}}>
              Open default example
            </AtlasButton>
          </Dialog.Trigger>
          <AlertDialog heading="Alert Dialog Heading">
            <AlertDialogBody>Dialog description here.</AlertDialogBody>
            <AlertDialogFooter>
              <Dialog.Close asChild>
                <AtlasButton appearance="subtle" sx={{fontSize: 3}}>
                  Cancel
                </AtlasButton>
              </Dialog.Close>
              <Dialog.Close asChild>
                <AtlasButton appearance="primary" sx={{fontSize: 3}}>
                  Confirm
                </AtlasButton>
              </Dialog.Close>
            </AlertDialogFooter>
          </AlertDialog>
        </Dialog>
      )}
    </Box>
  )
}

export const AlertDialogWarningExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)

  useEffect(() => {
    setDomLoaded(true)
  }, [])

  return (
    <Box>
      {domLoaded && (
        <Dialog>
          <Dialog.Trigger asChild>
            <AtlasButton sx={{backgroundColor: 'background.warning.default.[default]', fontSize: 3}}>
              Open warning example
            </AtlasButton>
          </Dialog.Trigger>
          <AlertDialog heading="Alert Dialog Heading" appearance="warning" size="md">
            <AlertDialogBody>Dialog description here.</AlertDialogBody>
            <AlertDialogFooter>
              <Dialog.Close asChild>
                <AtlasButton appearance="subtle" sx={{fontSize: 3}}>
                  Cancel
                </AtlasButton>
              </Dialog.Close>
              <Dialog.Close asChild>
                <AtlasButton appearance="warning" sx={{fontSize: 3}}>
                  Confirm
                </AtlasButton>
              </Dialog.Close>
            </AlertDialogFooter>
          </AlertDialog>
        </Dialog>
      )}
    </Box>
  )
}

export const AlertDialogDangerExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)

  useEffect(() => {
    setDomLoaded(true)
  }, [])

  return (
    <Box>
      {domLoaded && (
        <Dialog>
          <Dialog.Trigger asChild>
            <AtlasButton sx={{backgroundColor: 'background.danger.default.[default]', fontSize: 3}}>
              Open danger example
            </AtlasButton>
          </Dialog.Trigger>
          <AlertDialog heading="Alert Dialog Heading" appearance="danger" size="md">
            <AlertDialogBody>Dialog description here.</AlertDialogBody>
            <AlertDialogFooter>
              <Dialog.Close asChild>
                <AtlasButton appearance="subtle" sx={{fontSize: 3}}>
                  Cancel
                </AtlasButton>
              </Dialog.Close>
              <Dialog.Close asChild>
                <AtlasButton appearance="danger" sx={{fontSize: 3}}>
                  Confirm
                </AtlasButton>
              </Dialog.Close>
            </AlertDialogFooter>
          </AlertDialog>
        </Dialog>
      )}
    </Box>
  )
}

export const AlertDialogSuccessExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)

  useEffect(() => {
    setDomLoaded(true)
  }, [])

  return (
    <Box>
      {domLoaded && (
        <Dialog>
          <Dialog.Trigger asChild>
            <AtlasButton sx={{backgroundColor: 'background.success.default.[default]', fontSize: 3}}>
              Open success example
            </AtlasButton>
          </Dialog.Trigger>
          <AlertDialog heading="Alert Dialog Heading" appearance="success" size="md">
            <AlertDialogBody>Dialog description here.</AlertDialogBody>
            <AlertDialogFooter>
              <Dialog.Close asChild>
                <AtlasButton appearance="subtle" sx={{fontSize: 3}}>
                  Cancel
                </AtlasButton>
              </Dialog.Close>
              <Dialog.Close asChild>
                <AtlasButton appearance="primary" sx={{fontSize: 3}}>
                  Confirm
                </AtlasButton>
              </Dialog.Close>
            </AlertDialogFooter>
          </AlertDialog>
        </Dialog>
      )}
    </Box>
  )
}
